module.exports = __webpack_public_path__ + "img/time_line_img08.0992d50a.png";